import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import R from 'ramda'
import moment from 'moment'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import FinancesActions from '../../Data/Redux/FinancesRedux'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class Finances extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
      selectedCountry: null,
      symbol: '',
      code: '',
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getFinances } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'finances')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'finances')
      }
    } else {
      getFinances()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { finances, centers, user, countries, fromCenter, centersInfo } = nextProps
    if ((finances || centersInfo) && centers.length > 0) {
      if (user === 'Director') {
        const newData = []
        Object.keys(finances).map((date) => {
          const day = { day: date, formatDay: moment(date).format('MMM DD') }
          let total = 0
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === finances[date].center_id)
            day[abbreviation] = parseFloat(finances[date].total)
            total += parseFloat(finances[date].total)
            this.setState({ symbol: finances[date].formatted_total[0], code: finances[date].formatted_total.substr(finances[date].formatted_total.length - 3) })
          }
          day['total'] = total
          newData.push(day)
        })
        this.setState({ data: newData })
      } else if (fromCenter) {
        const newData = []
        Object.keys(centersInfo).map((date) => {
          const day = { day: date, formatDay: moment(date).format('MMM DD') }
          let total = 0
          if (centers.length > 0) {
            const { abbreviation } = centers.find(center => center.id === centersInfo[date].center_id)
            day[abbreviation] = parseFloat(centersInfo[date].total)
            total += parseFloat(centersInfo[date].total)
            this.setState({ symbol: centersInfo[date].formatted_total[0], code: centersInfo[date].formatted_total.substr(centersInfo[date].formatted_total.length - 3) })
          }
          day['total'] = total
          newData.push(day)
        })
        this.setState({ data: newData })
      } else {
        const newData = []
        for (let i = 0; i < finances.length; i++) {
          const country = countries.find(c => c.id === finances[i].country_id)
          if (country) {
            this.setState({ selectedCountry: country.name })
            const data = { name: country.name, totals: [] }
            Object.keys(finances[i].totals).map((date) => {
              const day = { day: date, formatDay: moment(date).format('MMM DD') }
              let total = 0
              finances[i].totals[date].map((d) => {
                if (centers.length > 0) {
                  const { abbreviation } = centers.find(center => center.id === d.center_id)
                  day[abbreviation] = parseFloat(d.total)
                  total += parseFloat(d.total)
                  day.symbol = d.formatted_total[0]
                  day.code = d.formatted_total.substr(d.formatted_total.length - 3)
                }
              })
              day['total'] = total
              data.totals.push(day)
            })
            newData.push(data)
          }
        }
        this.setState({ data: newData })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getBars = (data) => {
    if (this.props.user === 'Director') {
      const selectedCenter =
      this.props.centers.find(center => center.id === this.props.user_center_id)
      return (
        <Bar dataKey={selectedCenter.abbreviation} stackId="a" fill={this.pickColor(selectedCenter.abbreviation) ? COLORS[0 % COLORS.length] : 'gray'} />
      )
    }
    if (this.props.fromCenter) {
      const selectedCenter =
      this.props.centers.find(center => center.id == this.props.activeCenter)
      return (
        <Bar dataKey={selectedCenter.abbreviation} stackId="a" fill={this.pickColor(selectedCenter.abbreviation) ? COLORS[0 % COLORS.length] : 'gray'} />
      )
    }
    if (data.totals[0]) {
      const newCenters = []
      Object.keys(data.totals[0]).map((key) => {
        const selected = this.props.centers.find(center => center.abbreviation == key)
        if (selected) {
          newCenters.push(selected)
        }
      })
      const bars = newCenters.map((value, index) => {
        return (
          <Bar key={index} dataKey={value.abbreviation} stackId="a" fill={this.pickFinanceColor(value.abbreviation, data.name) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
      return bars
    }
  }

  getReports = () => {
    const { centers } = this.props
    const { width, data } = this.state
    const reports = data.map((currentValue, index) => {
      return (
        <ReportTemplate
          key={index}
          title={`Ingresos (${currentValue.name})`}
          date={{ initial: currentValue.totals[0].day, end: currentValue.totals[currentValue.totals.length - 1].day }}
          onClick={this.download}
          loading={!(centers.length > 0)}
        >
          {centers.length > 0 &&
            <BarChart
              width={width < 763 ? 400 : 648}
              height={width < 763 ? 300 : 400}
              data={currentValue.totals}
              margin={{ top: 40, right: 50, left: 30, bottom: 40 }}
            >
              <CartesianGrid vertical={false} />
              <XAxis dataKey="formatDay" />
              <YAxis />
              <Tooltip content={<Tool large prefix={currentValue.totals[0].symbol} suffix={currentValue.totals[0].code} />} />
              <Legend content={<CustomizedLegend onClick={event => this.filter(event, currentValue.name)} />} />
              {this.getBars(currentValue)}
            </BarChart>
          }
        </ReportTemplate>
      )
    })

    return reports
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] !== '0' && this.state.data[i][name] !== null) {
        count++
      }
    }
    return count > 0
  }

  pickFinanceColor = (name, country) => {
    if (country) {
      let count = 0
      const selectedData = this.state.data.find(d => d.name === country)
      for (let i = 0; i < selectedData.totals.length; i++) {
        if (selectedData.totals[i][name] != '0' && selectedData.totals[i][name] != null) {
          count++
        }
      }
      return count > 0
    }
  }

  filter = (event, country) => {
    const { finances, centers, countries } = this.props
    const abbreviation = event.currentTarget.id
    const selectedCountry = countries.find(c => c.name === country)
    let selectedFinance = null
    const newState = { ...this.state }
    const newData = newState.data.find(d => d.name === country)
    for (let i = 0; i < finances.length; i++) {
      selectedFinance = finances.find(f => f.country_id === selectedCountry.id)
    }
    for (let i = 0; i < newData.totals.length; i++) {
      if (newData.totals[i][abbreviation] && (newData.totals[i][abbreviation] !== 0 && newData.totals[i][abbreviation] !== null)) {
        newData.totals[i][abbreviation] = null
        const { day } = newData.totals[i]
        const finance = selectedFinance.totals[day]
        const newCenter = centers.find(c => c.abbreviation === abbreviation)
        const newFinance = finance.find(fin => fin.center_id === newCenter.id)
        newData.totals[i]['total'] -= parseFloat(newFinance.total)
      } else if (newData.totals[i][abbreviation] === 0 || newData.totals[i][abbreviation] === null) {
        const { day } = newData.totals[i]
        const finance = selectedFinance.totals[day]
        const newCenter = centers.find(c => c.abbreviation === abbreviation)
        const newFinance = finance.find(fin => fin.center_id === newCenter.id)
        newData.totals[i][abbreviation] = parseFloat(newFinance.total)
        newData.totals[i]['total'] += parseFloat(newFinance.total)
      }
    }
    const activeDataIndex = R.findIndex(R.propEq('name', newData.name))(newState.data)
    newState.data[activeDataIndex] = newData
    newState.selectedCountry = country
    this.setState(newState)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('finances', this.props.activeCenter)
    } else {
      this.props.getFinancesExcel()
    }
  }

  render() {
    const { centers, user, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <div>
        {(user === 'Director' || fromCenter) ?
          <ReportTemplate
            title="Ingresos"
            onClick={this.download}
            date={data[0] &&
              { initial: data[0].day, end: data[data.length - 1].day }}
            loading={!(centers.length > 0)}
          >
            {centers.length > 0 &&
              <BarChart
                width={width < 763 ? 400 : 648}
                height={width < 763 ? 300 : 400}
                data={data}
                margin={{ top: 40, right: 50, left: 30, bottom: 40 }}
              >
                <CartesianGrid vertical={false} />
                <XAxis dataKey="formatDay" />
                <YAxis />
                <Tooltip content={<Tool prefix={this.state.symbol} suffix={this.state.code} />} />
                <Legend content={<CustomizedLegend />} />
                {this.getBars()}
              </BarChart>
            }
          </ReportTemplate>
          :
          this.getReports()}
      </div>
    )
  }
}


const mapStateToProps = ({ finances, centerOptions, auth, countries, centersInfo }) => ({
  finances: finances.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  countries: countries.get.results,
  user_center_id: auth.user.center_id,
  centersInfo: centersInfo.finances.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getFinances: () => dispatch(FinancesActions.getRequest({}, true)),
  getRatings: () => dispatch(RatingsActions.getRequest({}, true)),
  getFinancesExcel: () => dispatch(FinancesActions.FinancesExcelRequest()),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Finances))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Finances.jsx